import axios from "axios";

export default {
    getMyInfo() {
        return axios.get("/course/Usercenter/getMyInfo");
    },
    getMyCouponList() {
        return axios.get("/course/Coupon/myList");
    },
    /**
     * @param {Object} obj 
     * @param {String} obj.code
     */
    checkCode(obj) {
        return axios.post("/course/Usercenter/checkCode", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.content 
     */
    feedback(obj) {
        return axios.post("/course/Usercenter/feedback", obj);
    },
    /**
     * @param {Object} obj 
     * @param {String} obj.page
     */
    userLetter(obj) {
        return axios.post("/course/Usercenter/userLetter", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.id 
     */
    getLetterById(obj) {
        return axios.post("/course/Usercenter/getLetterById", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.page 
     */
    userMessage(obj) {
        return axios.post("/course/Usercenter/userMessage", obj);
    },
    getRechargeConfig() {
        return axios.get("/course/Usercenter/getRechargeConfig");
    },
    ifNewLetter() {
        return axios.get("/course/Usercenter/ifNewLetter");
    },
    /**
     * 
     * @param {Obect} obj 
     * @param {String} obj.goodsCode - STUDY STUDY_ZUHE STUDENT
     * @param {String} obj.goodsId
     * @param {String} obj.buyMember 
     * @param {String} obj.phone 
     * @param {String} obj.payType - WX NIUBI
     */
    createOrder(obj) {
        return axios.post("/course/Sale/createOrder", obj);
    },
    getGoldPayList() {
        return axios.get("/course/Usercenter/getGoldPayList");
    },
    payList() {
        return axios.get("/course/Usercenter/payList");
    },
    getOtherInfo() {
        return axios.get("/course/Usercenter/getOtherInfo");
    },
    ifNeedReNew() {
        return axios.get("/cc/Student/ifNeedRenew");
    },
    getNiuzhiScoreList() {
        return axios.get("/course/Usercenter/getNiuzhiScoreList");
    },
    ifChargeSale() {
        return axios.get("/course/Usercenter/ifChargeSale");
    }
}